<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">企業詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_COMPANY_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="back">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
              :rules="codeRules"
                label="企業CD"
                style="padding-top: 0px; padding-bottom: 0px"
                v-model.trim="query.code"
                :disabled="query.companyId"
              />
            </v-flex>
            <v-flex md3 offset-md3 sm6 xs12>
              <remote-autocomplete
                label="所在地"
                url="countries/kv"
                v-model="query.countryCode"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="query.type === 'SHARP'">
            <v-flex md6 sm6 xs12>
              <v-text-field label="企業英語名称" v-model="query.englishName" />
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-text-field label="英語住所" v-model="query.englishAddress" />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="query.type === 'SHARP'">
            <v-flex md6 sm6 xs12>
              <v-text-field label="企業日本語名称" v-model="query.name" />
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-text-field label="日本語住所" v-model="query.address" />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="query.type !== 'SHARP'">
            <v-flex md6 sm6 xs12>
              <v-text-field label="企業名称" v-model="query.name" />
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-text-field label="住所" v-model="query.address" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <v-text-field label="表示用略称" v-model="query.displayName" />
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-text-field label="代表電話" v-model="query.tel" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <v-text-field label="担当窓口" v-model="query.contact" />
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-text-field label="連絡Email" v-model="query.email" />
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field label="代表FAX" v-model="query.fax" />
            </v-flex>

            <v-flex md2 sm6 offset-md3 xs12 v-if="query.type === 'OVERSEAS'">
              <v-select
                :items="monthConditions"
                clearable
                item-text="text"
                item-value="value"
                label="回収条件（納入完了日ベース）"
                v-model="query.monthCondition"
              />
            </v-flex>

            <v-flex md1 sm6>
              <v-text-field value="締め" :disabled="true"> </v-text-field>
            </v-flex>

            <v-flex md2 sm6 xs12 v-if="query.type === 'OVERSEAS'">
              <v-select
                :items="nextMonthConditions"
                clearable
                item-text="text"
                item-value="value"
                label="回収条件（納入完了日ベース）"
                v-model="query.nextMonthCondition"
              />
            </v-flex>

            <v-flex md1 sm6>
              <v-text-field value="回収" :disabled="true"> </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                label="企業区分"
                readonly
                v-if="
                  query.type != null &&
                  (query.type === 'SJL' || query.type === 'SHARP')
                "
                v-model="query.type"
              ></v-text-field>
              <v-select
                :items="$store.state.companyType"
                :rules="typeRules"
                item-text="text"
                item-value="value"
                label="企業区分"
                v-else
                v-model="query.type"
                :disabled="!!query.companyId"
              ></v-select>
            </v-flex>
            <v-flex v-if="query.type === 'PARTNER'" md6 offset-md3 sm6 xs12>
              <v-checkbox label="SYTC" v-model="query.isSytc"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout
            row
            v-if="query.type === 'SUPPLIER' || query.type === 'OVERSEAS'"
            wrap
          >
            <v-flex md3>
              <v-checkbox
                label="Jusdaサプライヤーか？（経理SAP用）"
                v-model="query.isJusda"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout
            row
            v-if="query.type === 'SUPPLIER' || query.type === 'OVERSEAS'"
            wrap
          >
            <v-flex md3>
              <v-text-field
                :label="
                  query.type === 'SUPPLIER'
                    ? 'Jpy Vender Code（経理SAP用）'
                    : '得意先コード(JPY)'
                "
                v-model="query.jpyVendorCode"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout
            row
            v-if="query.type === 'SUPPLIER' || query.type === 'OVERSEAS'"
            wrap
          >
            <v-flex md3>
              <v-text-field
                :label="
                  query.type === 'SUPPLIER'
                    ? 'Usd Vender Code（経理SAP用）'
                    : '得意先コード(USD)'
                "
                v-model="query.usdVendorCode"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row v-if="query.type === 'SUPPLIER'" wrap>
            <v-flex md3>
              <v-text-field
                label="Business area（AR用）"
                v-model="query.businessArea"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row v-if="query.type === 'SUPPLIER'" wrap>
            <v-flex md3>
              <v-text-field
                label="Functional Area（AR用）"
                v-model="query.functionArea"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row v-if="query.type === 'SHARP' || query.type === 'OVERSEAS'" wrap>
            <v-flex md3>
              <v-text-field
                label="customNumber（JusFin用）"
                v-model="query.customerCode"
                :rules="[(v) => !!v || 'customNumber（JusFin用） is required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row v-if="query.type === 'SHARP' || query.type === 'OVERSEAS' || query.type == 'SUPPLIER' " wrap>
            <v-flex md3>
              <v-text-field
                label="merchantLegalNumber（JusFin用）"
                v-model="query.customerLegalPersonCode"
                :rules="[(v) => !!v || 'merchantLegalNumber（JusFin用） is required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row v-if="query.type === 'SJL'" wrap>
            <v-flex md3>
              <v-text-field
                label="登録番号"
                v-model="query.registrationNumber"
                :rules="[(v) => !!v || '登録番号 is required']"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <sharp-card
      :company="query"
      :key="query.type"
      @refresh="load"
      @updateBlDirector="updateBlDirector"
      ref="sharp"
      v-if="query.type == 'SHARP'"
    ></sharp-card>
    <world-card
      :company="query"
      :key="query.type"
      @refresh="load"
      ref="world"
      v-if="query.type == 'PARTNER'"
    ></world-card>
    <supplier-card
      :company="query"
      :key="query.type"
      ref="supplier"
      v-if="query.type == 'SUPPLIER'"
    ></supplier-card>
    <inner-card
      :company="query"
      :key="query.type"
      ref="InnerCard"
      v-if="query.type == 'SUPPLIER' && customCanShow"
    ></inner-card>
    <buyer-card
      :company="query"
      :key="query.type"
      ref="buyer"
      v-if="query.type == 'BUYER'"
    ></buyer-card>

    <production-base-card
      :company="query"
      :key="query.type"
      ref="productionBase"
      v-if="query.type == 'PRODUCTION_BASE'"
    ></production-base-card>
  </v-container>
</template>

<script>
import SharpCard from "./SharpCard.vue";
import SupplierCard from "./SupplierCard.vue";
import WorldCard from "./WorldCard.vue";
import InnerCard from "./InnerCard.vue";
import BuyerCard from "./BuyerCard.vue";
import ProductionBaseCard from "./ProductionBaseCard.vue";
export default {
  components: {
    SharpCard,
    SupplierCard,
    WorldCard,
    InnerCard,
    BuyerCard,
    ProductionBaseCard,
  },
  data() {
    return {
      errors: {
        CODE_EXIST: "当該企業CDは既に存在しています。",
      },
      valid: true,
      codeRules: [(v) => !!v || "企業CD is required"],
      typeRules: [(v) => !!v || "企業区分 is required"],
      monthConditions: [
        { text: "月末", value: "month-end" },
        { text: "每月5日", value: "month-05" },
        { text: "每月10日", value: "month-10" },
        { text: "每月15日", value: "month-15" },
        { text: "每月20日", value: "month-20" },
        { text: "每月25日", value: "month-25" },
      ],
      nextMonthConditions: [
        { text: "翌月末", value: "month-end" },
        { text: "翌月5日", value: "month-05" },
        { text: "翌月10日", value: "month-10" },
        { text: "翌月15日", value: "month-15" },
        { text: "翌月20日", value: "month-20" },
        { text: "翌月25日", value: "month-25" },
      ],

      type: "",

      services: [
        {
          type: "FORWARDER",
        },
        {
          type: "CUSTOMS_CLEARANCE",
        },
        {
          type: "DRAKE",
        },
        {
          type: "DEVAN",
        },
        {
          type: "CHARTER",
        },
        {
          type: "MIXLOADING",
        },
      ],
      accs: {
        Delivery_Director: [],
        Release_Director: [],
        SJL_Director: [],
        Customs_Director: [],
        BL_Director: [],
        IMPORT_SALES: [],
        IMPORT_PROMOTE: [],
      },
      query: {
        services: [
          {
            type: "FORWARDER",
          },
          {
            type: "CUSTOMS_CLEARANCE",
          },
          {
            type: "DRAKE",
          },
          {
            type: "DEVAN",
          },
          {
            type: "CHARTER",
          },
          {
            type: "MIXLOADING",
          },
        ],
        accs: {
          Delivery_Director: [],
          Release_Director: [
            {
              releaseDirectorId1: "",
              releaseDirectorId2: "",
              releaseDirectorId3: "",
            },
          ],
          SJL_Director: [],
          Customs_Director: [],
          BL_Director: [],
          IMPORT_SALES: [],
          IMPORT_PROMOTE: [],
        },
      },
    };
  },
  methods: {
    updateBlDirector(company) {
      this.query = {
        ...company,
      };
    },
    back() {
      this.$router.go(-1);
    },
    //TODO 需要对列表的seq算法生成机制进行重构
    load() {
      if (this.$route.query.id != null) {
        this.$http.get(`/companies/${this.$route.query.id}`).then((res) => {
          this.query = res.data;
          if (this.query.accs.Release_Director.length == 0) {
            this.query.accs.Release_Director.push({
              releaseDirectorId1: "",
              releaseDirectorId2: "",
              releaseDirectorId3: "",
            });
          }
          this.query.accs.BL_Director = (this.query.accs.BL_Director || []).map(
            (d, idx) => ({
              ...d,
              key: new Date().getTime() + idx,
            })
          );
          this.query.accs.Delivery_Director = (
            this.query.accs.Delivery_Director || []
          ).map((d, idx) => ({
            ...d,
            key: new Date().getTime() + idx,
          }));
          if (
            !this.query.accs.IMPORT_SALES ||
            this.query.accs.IMPORT_SALES.length == 0
          ) {
            this.query.accs.IMPORT_SALES = [];
          }
          if (
            !this.query.accs.IMPORT_PROMOTE ||
            this.query.accs.IMPORT_PROMOTE.length == 0
          ) {
            this.query.accs.IMPORT_PROMOTE = [];
          }
          if (this.query.accs)
            if (this.query.services.length == 0) {
              this.query.services = this.services;
            }
          //set list seq(key)
          Object.entries(this.query.accs).forEach((entry) => {
            entry[1].forEach((p, idx) => (p.key = new Date().getTime() + idx));
          });
          this.$refs.sharp.createShowData(res.data);
        });
      }
    },
    save() {
      if (
        this.query.type === "SUPPLIER" &&
        (!this.query.jpyVendorCode ||
          this.query.jpyVendorCode === "" ||
          !this.query.usdVendorCode ||
          this.query.usdVendorCode === "")
      ) {
        this.$message("", "Jpy Vender Code、Usd Vender Codeが必須項目です。");
        return;
      } else {
        if (this.$route.query.id == null) {
          this.$http
            .post("/companies", this.query)
            .then((res) => {
              if ("BUYER" === this.query.type) {
                var codes = this.$refs.buyer.buyerCodes;
                if (codes.length > 0) {
                  this.$http
                    .post(
                      `/buyers/codes`,
                      codes.map((c) => {
                        return {
                          ...c,
                          parentCompanyId: res.data.companyId,
                        };
                      })
                    )
                    .then(() => {
                      this.$router.push("/M0030");
                    })
                    .catch((err) => {
                      this.$router.push("/M0030");
                      this.$showError(err);
                    });
                }
              }
              if ("PRODUCTION_BASE" === this.query.type) {
                var codes = this.$refs.productionBase.expenseCodes;
                if (codes.length > 0) {
                  this.$http
                    .post(
                      `/expense-codes/codes`,
                      codes.map((c) => {
                        return {
                          ...c,
                          parentCompanyId: res.data.companyId,
                        };
                      })
                    )
                    .then(() => {
                      this.$router.push("/M0030");
                    })
                    .catch((err) => {
                      this.$router.push("/M0030");
                      this.$showError(err);
                    });
                }
              }
              this.$router.push("/M0030");
            })
            .catch((err) => {
              this.$showError(err);
            });
        } else {
          this.$http
            .put("/companies", this.query)
            .then(() => {
              this.$router.push("/M0030");
            })
            .catch((err) => {
              this.$showError(err);
            });
        }
      }
    },
  },
  computed: {
    customCanShow() {
      var custom = this.query.services.filter(
        (s) => s.type === "CUSTOMS_CLEARANCE"
      )[0];
      if (custom.startDate && custom.endDate) {
        var start = new Date(custom.startDate);
        var end = new Date(custom.endDate);
        var now = new Date();
        if (start < now && end > now) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    hasClearDate() {
      return null;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style>
.v-form > .container > .layout > .flex {
  padding-top: 8px !important;
  padding-bottom: 0px !important;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
